export var defaultBaseProps = {
    className: '',
    style: undefined,
    type: 'line',
    percent: 0,
    showInfo: true,
    strokeLinecap: 'round',
    strokeColor: '#1890ff',
    trailColor: '#f5f5f5',
    status: 'normal',
};
export var defaultBaseLineProps = {
    strokeWidth: 8,
};
export var defaultBaseCircleProps = {
    width: 128,
    strokeWidth: 8,
    gapDegree: 0,
    gapPosition: 'top',
};
